


import React, { useEffect, useState } from "react";
import { StepIndicator } from "../../components/marketing/campaign/indicator";
import { CampaignSetup } from "../../components/marketing/campaign/campaign-details/campaign-setup";
import { CampaignData } from "../../components/types";
import { useNavigate } from "react-router-dom";
import { steps } from "./data";
import useRequest from "../../components/hook/use-req";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import { SingleAudienceResponse, SingleCampaignResponse, WalletBalanceData } from "../campaign/types";
import { ArrowLeft } from "lucide-react";
import BroadcastDraft from "../../components/marketing/campaign/broadcast-draft";
import Messaging from "../../components/marketing/campaign/messaging";
import ScheduleLaunch from "../../components/marketing/campaign/shedule-launch";
import { AIContentCreation } from "../../components/marketing/campaign/content-creation";

const SMSCampaignFlow = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const draftCampaignId = localStorage.getItem("draftCampaignId");
  const draftAudienceId = localStorage.getItem("draftAudienceId");
  const [singleCampaign, setSingleCampaign] = useState<SingleCampaignResponse | null>(null);
  const [currentStep, setCurrentStep] = useState(2);
  const [walletBallance, setWlletBallance] = useState<WalletBalanceData | null>(null);
const [audienceById, setAudienceById] = useState<SingleAudienceResponse | null>(null);
  const [campaignData, setCampaignData] = useState<CampaignData>({
    sender_name: "",
    audienceId: "",
    campaign_name: "",
    campaign_channel: "",
    campaign_type: "",
    previewText: "",
    html_text: "",
    plain_text: "",
    email_header: "",
    emailCss: "",
    date: "",
    link: "",
    subject: "",
    audioUrl: "",
    smsSegment: 0,
    campaign_goal: "",
    broadcast_tags: [],
    timezone: "",
    business_category: "",
    contacts: 0,
    typedNumbers: [],
    messages: "",
    scheduled_start: "",
    audienceSize: "",
    aiSettings: {},
    id: 0,
    countryCounts: 0,
    uploadDate: "",
    totalRecords: 0,
    validRecords: 0,
    invalidRecords: 0,
    duplicateRecords: 0,
    preview: [],
    data: [],
    send_now: false,
    voice_id: "",
    selectedAudiences: [],
    uploadAudienceId: null,
    manualAudienceId: null,
    tags: [],
    uploadedContacts: 0,
    manualValidRecords: 0,
  });

  const { makeRequest: getCampaignById } = useRequest(`/campaign/details/${draftCampaignId}`, "GET", {
    Authorization: `Bearer ${token}`,
  });

  const { makeRequest: getAudienceByid } = useRequest(`/audience/${draftAudienceId}`, "GET", {
    Authorization: `Bearer ${token}`,
  });
  const { makeRequest: WalletBalance } = useRequest("/wallet/balance", "GET", {
    Authorization: `Bearer ${token}`,
  });


  function backToCampaign() {
    navigate("/campaign");
    localStorage.removeItem("draftCampaignId");
    localStorage.removeItem("draftAudienceId");
    window.location.reload();
  }

  const { handleSubmit, control, setValue } = useForm();
  // Validation states for each step
  const [stepValidation, setStepValidation] = useState({
    step1Valid: false,
    step2Valid: false,
    step3Valid: false,
    step4Valid: false,
  });

  useEffect(() => {
    if (!token) {
      window.location.reload();
    }
  }, [token, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      if (draftCampaignId) {
        const [response] = await getCampaignById();
        setSingleCampaign(response?.response);
      }
    };

    fetchData();
  }, [draftCampaignId]);


 useEffect(() => {
    const fetchData = async () => {
      if (draftAudienceId) {
        const [response] = await getAudienceByid();
        setAudienceById(response);
      }

    };
    fetchData();
  }, [draftAudienceId]);


  useEffect(() => {
    const fetchData = async () => {
      const [response] = await WalletBalance();
      setWlletBallance(response?.data);
    };
    fetchData();
  }, []);

  // Submit handlers for each step
  const handleStep1Submit = (data: Partial<CampaignData>) => {
    const formattedData = {
      ...data,
      date: data.date ? data.date.toISOString() : "",
    };

    setCampaignData((prev) => ({ ...prev, ...formattedData }));
    setStepValidation((prev) => ({ ...prev, step1Valid: true }));
    setCurrentStep(3);
  };



  const handleStep4Submit = (data: Partial<CampaignData>) => {
    setCampaignData((prev) => ({ ...prev, ...data }));
    navigate("/campaign");
    toast.success("Campaign setup created successfully!");
  };

  // Validation handlers to update step validation status
  const handleStep1Validation = (isValid: boolean) => {
    setStepValidation((prev) => ({ ...prev, step1Valid: isValid }));
  };


  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <BroadcastDraft />
        );
      case 2:
        return (
          <CampaignSetup
            campaignData={campaignData}
            singleCampaign={singleCampaign}
            setCampaignData={setCampaignData}
            onSubmit={handleStep1Submit}
            onValidation={handleStep1Validation}
            audienceById={audienceById}
          />
        );
      case 3:
        return (
          <AIContentCreation
            campaignData={campaignData}
            singleCampaign={singleCampaign}
            setCampaignData={setCampaignData}
            onSubmit={(data) => {
              setCampaignData(prev => ({ ...prev, ...data }));
              setStepValidation(prev => ({ ...prev, step3Valid: true }));
              setCurrentStep(4);
            }}
            onValidation={(isValid) => {
              setStepValidation(prev => ({ ...prev, step3Valid: isValid }));
            }}
             onBack={() => setCurrentStep(2)}
          />
        );
      case 4:
        return (

          <ScheduleLaunch
            campaignData={campaignData}
            walletBallance={walletBallance}
            singleCampaign={singleCampaign}
            setCampaignData={setCampaignData}
            onSubmit={handleStep4Submit}
                onBack={() => setCurrentStep(3)}
          />
        );
      default:
        return (
          <CampaignSetup
            campaignData={campaignData}
            singleCampaign={singleCampaign}
            setCampaignData={setCampaignData}
            onSubmit={handleStep1Submit}
            onValidation={handleStep1Validation}
            audienceById={audienceById}
          />
        );
    }
  };



  return (
    <>
      <div className="min-h-screen">
        <div className="bg-white rounded-lg px-6 py-5">
          <h1 className="flex text-[20px] font-medium">
            <button className="flex gap-5" onClick={backToCampaign}>
              <ArrowLeft /> <span className="text-gray-400"> All Broadcasts </span>
            </button> / <strong className="text-[#3A3428]"> New Broadcast </strong>
          </h1>
          <div className="lg:flex gap-7 my-5">
            {steps.map((step) => (
              <div
                key={step.id}
                className="cursor-pointer w-full"
                onClick={() => {
                  // Allow clicking on any step up to current step
                  if (step.id <= currentStep) {
                    setCurrentStep(step.id);
                  }
                }}
              >
                <StepIndicator
                  step={step}
                  isActive={currentStep === step.id}
                  isCompleted={currentStep > step.id}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="grid w-full gap-8">

          <div className="w-full">
            <div className="bg-slate-100 rounded-lg border border-gray-200 p-6">
              {renderStep()}

              {/* <div className="flex justify-between mt-8 pt-6 border-t border-gray-200">
                <button
                  onClick={goPrev}
                  disabled={currentStep === 1}
                  className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  ← Previous
                </button>

                {currentStep === 4 ? (
                  <></>
                ) : (
                  <button
                    onClick={handleNextClick}
                    type="button"
                    disabled={loading}
                    className={`px-6 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:from-blue-600 hover:to-blue-700 ${
                      loading ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  >
                    {loading ? "Loading..." : "Next →"}
                  </button>
                )}
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SMSCampaignFlow;